<script lang="ts">
  import { CollapsibleContent } from '../../collapsible';
  import { accordionStyles } from '../accordion-styles';
  import type { AccordionContentProps } from '../accordion.types';
  import { useAccordionContext } from '../use-accordion-context';
  import { useAccordionItemContext } from '../use-accordion-item-context';

  const { title } = useAccordionItemContext();

  const classes = accordionStyles();

  const { children, ...itemProps }: AccordionContentProps = $props();
  const accordion = useAccordionContext();
</script>

<CollapsibleContent>
  <div {...accordion.api.getItemContentProps({ value: title, ...itemProps })} hidden={false} class={classes.itemContent}>
    {@render children()}
  </div>
</CollapsibleContent>
